<template>
  <div class="education-page">
    <NavBar />
    <main class="education-main">
      <header class="page-heading">
        <div><span class="eyebrow">ÖĞRENME PLANIM</span><h1>Eğitim Planım</h1><p>Ders takvimini, eğitim paketini ve gelişimini tek bir yerden takip et.</p></div>
        <router-link to="/lesson-schedule" class="secondary-action"><i class="bi bi-calendar3" aria-hidden="true"></i> Ders Takvimi</router-link>
      </header>
      <div class="education-layout">
        <div class="education-content">
          <section class="lesson-panel" aria-labelledby="lesson-title">
            <div>
              <span class="lesson-status" :class="{ 'is-live': MeetingVisible }"><span class="status-dot" aria-hidden="true"></span>{{ MeetingVisible ? 'Dersin başladı' : 'Canlı ders' }}</span>
              <h2 id="lesson-title">Canlı Dersim</h2>
              <p v-if="lessonTime"><i class="bi bi-clock" aria-hidden="true"></i> Ders saati: {{ lessonTime }}</p>
              <p v-else>Ders takvimini incele, öğrenmeye kaldığın yerden devam et.</p>
              <a v-if="MeetingType == 10 && MeetingVisible" :href="MeetingUrl" target="_blank" rel="noopener noreferrer" class="primary-action">Online Derse Katıl <i class="bi bi-arrow-up-right" aria-hidden="true"></i></a>
              <router-link v-else-if="MeetingType == 99 && MeetingVisible" to="/zoom-call" target="_blank" rel="noopener noreferrer" class="primary-action">Online Derse Katıl <i class="bi bi-arrow-up-right" aria-hidden="true"></i></router-link>
              <template v-else><button type="button" class="primary-action" disabled aria-describedby="lesson-hint">Online Derse Katıl <i class="bi bi-arrow-up-right" aria-hidden="true"></i></button><small id="lesson-hint" class="lesson-hint">Ders saatinizde "Online Derse Katıl" tuşu aktif olacaktır.</small></template>
            </div>
            <img src="@/assets/images/education/dashboard/live-lesson.svg" alt="" width="480" height="320" class="lesson-art" decoding="async">
          </section>
          <nav class="quick-links" aria-label="Eğitim bağlantıları">
            <router-link :to="dailyLessonBookUrl ? '/courses/' + dailyLessonBookUrl : '/lesson-schedule'" class="quick-link"><span class="link-icon"><i class="bi bi-journal-text" aria-hidden="true"></i></span><span><strong>Günün dersi</strong><small>Kitabına ve konularına göz at</small></span><i class="bi bi-arrow-right" aria-hidden="true"></i></router-link>
            <router-link to="/invite" class="quick-link"><span class="link-icon"><i class="bi bi-people" aria-hidden="true"></i></span><span><strong>Arkadaşını davet et</strong><small>Birlikte öğren, davet programını keşfet</small></span><i class="bi bi-arrow-right" aria-hidden="true"></i></router-link>
          </nav>
          <div class="training-section">
            <TrainingInfo @DailyLessonBookUrl="GetBookUrl($event)" @LessonTimeHandler="GetLessonTime($event)">
              <template #lesson-image><img src="@/assets/images/education/dashboard/lesson-book.svg" alt="" width="120" height="120" class="training-art" loading="lazy" decoding="async"></template>
              <template #package-image><img src="@/assets/images/education/dashboard/learning-program.svg" alt="" width="120" height="120" class="training-art" loading="lazy" decoding="async"></template>
            </TrainingInfo>
          </div>
          <section class="progress-section" aria-labelledby="progress-title"><div class="section-heading"><h2 id="progress-title">Gelişim Takibim</h2><p>İngilizce yolculuğunda geldiğin noktayı gör.</p></div><LearningChart><template #progress-marker><span class="progress-marker" aria-hidden="true"><i class="bi bi-mortarboard"></i></span></template></LearningChart></section>
        </div>
        <aside class="education-sidebar" aria-label="Profil ve destek">
          <section class="sidebar-panel profile-panel" aria-label="Öğrenci profili">
            <span class="profile-avatar" aria-hidden="true">{{ studentInitials }}</span>
            <div class="profile-identity"><span class="eyebrow">ÖĞRENCİ</span><h2 class="student-name">{{ nameSurname }}</h2></div>
            <router-link to="/profile" class="profile-edit" aria-label="Profilimi düzenle" title="Profilimi düzenle"><i class="bi bi-pencil" aria-hidden="true"></i></router-link>
          </section>
          <section class="sidebar-panel" aria-labelledby="support-title" :aria-busy="operatorInfo.loading">
            <img class="coach-art" src="@/assets/images/education/dashboard/education-coach.svg" alt="" width="320" height="240" loading="lazy" decoding="async">
            <h2 id="support-title">Eğitim Koçum</h2><p>Eğitiminle ilgili soruların için bize ulaşabilirsin.</p>
            <div v-if="operatorInfo.loading" class="support-loading" role="status"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span> Koç bilgileri yükleniyor…</div>
            <template v-else><strong v-if="operatorInfo.name" class="coach-name">{{ operatorInfo.name }}</strong><a v-if="operatorInfo.phone" :href="'tel:' + operatorInfo.phone" class="phone-link"><i class="bi bi-telephone" aria-hidden="true"></i> {{ phoneFormat(operatorInfo.phone) }}</a><p v-if="!operatorInfo.name && !operatorInfo.phone" class="support-loading">Koç bilgilerin şu anda görüntülenemiyor.</p></template>
          </section>
          <router-link to="/faq" class="faq-link"><i class="bi bi-question-circle" aria-hidden="true"></i><span>Sıkça sorulan sorular</span><i class="bi bi-arrow-up-right" aria-hidden="true"></i></router-link>
        </aside>
      </div>
    </main>
    <FooterInPage />
  </div>
</template>

<script>
import { mapActions } from "vuex";
//import { ErrorToast } from "@/common/notification.js";
import NavBar from '@/components/Shared/NavBar.vue'
import FooterInPage from '@/components/Shared/FooterInPage.vue'
import TrainingInfo from '@/components/Home/TrainingInfo.vue'
import LearningChart from '@/components/Home/LearningChart.vue'

import store from "@/store";
export default {
  name: 'MyEducationPage',
  data() {
    return {
      operatorInfo:{
        loading:false,
        name:'',
        phone:''
      },
      dailyLessonBookUrl:'',
      lessonTime:''
    };
  },
  components: {
    NavBar,
    FooterInPage,
    TrainingInfo,
    LearningChart
  },
  computed:{
    studentInitials(){
      return (this.nameSurname || '').trim().split(/\s+/).filter(Boolean).map(part => Array.from(part)[0]).slice(0, 2).join('').toLocaleUpperCase('tr-TR') || 'Ö';
    },
    nameSurname(){
      return store.getters['NameSurname'];
    },
    MeetingUrl(){
      return store.getters['MeetingUrl'];
    },
    MeetingType(){
      return store.getters['MeetingType'];
    },
    MeetingVisible(){
        if(this.MeetingType==99 || (this.MeetingType==10 && !!this.MeetingUrl)){
          return true;
        }
        return false;
    },
    isDemoCreated: function() {
      return this.$store.getters.isDemoCreate;
    },
  },
  methods:{
    ...mapActions(["GetOperatorInfo"]),
    
    phoneFormat(value){
      if(value){
        let phone = '+90 '+value.substr(0,3)+' '+value.substr(3,3)+' '+value.substr(-4);
        return phone;
      }
      return value
    },
    async getOperatorInfo(){
      this.operatorInfo.loading=true;
      //let toastId = LoadingToast();
      await this.GetOperatorInfo()
      .then((res)=>{
        this.operatorInfo.name=res.name;
        this.operatorInfo.phone=res.phoneNumber;
        this.operatorInfo.loading=false;
        //UpdateToast(toastId,res.description,ToastType().SUCCESS,100);
      })
      .catch(()=>{
        this.operatorInfo.loading=false;
        //if(err.message){
        //  ErrorToast('GetOperatorInfo' + err.message);
        //}
      });
    },
    GetBookUrl(value){
      this.dailyLessonBookUrl = value;
    },
    GetLessonTime(value){
      this.lessonTime = value;
    }
  },
  mounted: function() {
    this.getOperatorInfo();
  }
}
</script>
<style scoped>
.education-page { min-height: 100vh; background: #f7f9fb; color: #253545; }
.education-main { max-width: 1180px; margin: auto; padding: 40px 28px 48px; }
.page-heading { display: flex; align-items: center; justify-content: space-between; gap: 24px; margin-bottom: 28px; }
.eyebrow { display: block; color: var(--brand-link); font-size: 11px; font-weight: 700; letter-spacing: 1.3px; margin-bottom: 10px; }
h1 { font-size: clamp(28px, 4vw, 36px); font-weight: 750; letter-spacing: -.8px; margin: 0 0 10px; }
p { color: #637480; font-size: 14px; line-height: 1.75; margin: 0; }
a { text-decoration: none; }
.education-layout { display: grid; grid-template-columns: minmax(0, 1fr) 270px; gap: 24px; align-items: start; }
.education-content, .education-sidebar { min-width: 0; }
.education-sidebar { display: grid; gap: 18px; }
.lesson-panel { display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 30px; border: 1px solid #dbeae3; border-radius: 20px; background: #eef7f2; }
.lesson-status { display: inline-flex; align-items: center; gap: 7px; color: #526a60; font-size: 12px; font-weight: 600; margin-bottom: 16px; }
.status-dot { width: 7px; height: 7px; border-radius: 50%; background: #82988d; }
.is-live { color: #087454; }
.is-live .status-dot { background: var(--brand-primary); box-shadow: 0 0 0 4px #d8eee3; }
.lesson-panel h2 { font-size: clamp(21px, 3vw, 26px); line-height: 1.4; font-weight: 700; letter-spacing: -.4px; margin: 0 0 10px; }
.lesson-panel p { margin-bottom: 22px; }
.lesson-panel > div { flex: 1; min-width: 0; }
.lesson-art { display: block; flex: 0 1 42%; width: 42%; max-width: 290px; height: auto; border-radius: 18px; mix-blend-mode: multiply; }
.training-art { display: block; width: 100%; height: 100%; object-fit: contain; mix-blend-mode: multiply; }
.progress-marker { display: grid; place-items: center; width: 40px; height: 40px; border: 3px solid white; border-radius: 14px; background: #e1eee5; color: var(--brand-link); font-size: 22px; box-shadow: 0 3px 10px #2535450d; }
.primary-action, .secondary-action { display: inline-flex; align-items: center; justify-content: center; gap: 12px; border-radius: 10px; padding: 12px 18px; font-size: 13px; font-weight: 600; }
.primary-action { background: var(--brand-primary); color: white; border: 1px solid var(--brand-primary); }
.primary-action:hover { background: var(--brand-primary-hover); }
.primary-action:disabled { background: #e0e8e3; border-color: #e0e8e3; color: #62756c; cursor: not-allowed; }
.secondary-action { background: var(--brand-soft); border: 1px solid #87cbb4; color: var(--brand-link); flex-shrink: 0; }
.secondary-action:hover { border-color: var(--brand-primary); background: #f0f7f3; }
.lesson-hint { display: block; font-size: 12px; color: #63766b; margin-top: 10px; }
.quick-links { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; margin: 18px 0 24px; }
.quick-link { display: flex; align-items: center; gap: 12px; padding: 18px; border: 1px solid #e4ecef; border-radius: 14px; background: white; color: inherit; }
.quick-link:hover { border-color: var(--brand-primary); box-shadow: 0 4px 16px #00856a12; }
.quick-link strong { color: var(--brand-link); }
.quick-link:nth-child(2) .link-icon { background: var(--brand-yellow-soft); color: var(--brand-yellow-text); }
.coach-art { display: block; width: 100%; max-width: 220px; height: auto; margin: 0 auto 12px; }
.primary-action:not(:disabled) { box-shadow: 0 4px 12px #00856a24; }
.link-icon { display: inline-grid; place-items: center; flex: 0 0 40px; width: 40px; height: 40px; border-radius: 11px; background: #eff7f3; color: var(--brand-link); font-size: 20px; }
.quick-link strong { display: block; font-size: 14px; font-weight: 650; }
.quick-link small { display: block; color: #637480; font-size: 12px; margin-top: 4px; }
.quick-link > .bi { margin-left: auto; color: var(--brand-link); }
.sidebar-panel { padding: 24px; border: 1px solid #e4ecef; border-radius: 16px; background: white; }
.profile-identity { flex: 1; min-width: 0; }
.profile-identity .eyebrow { margin-bottom: 4px; font-size: 10px; }
.profile-edit { display: grid; place-items: center; width: 36px; height: 36px; flex: 0 0 36px; border-radius: 10px; color: var(--brand-link); background: #eff7f3; }
.profile-edit:hover { background: #deeee5; }
.profile-panel { display: flex; align-items: center; gap: 12px; padding: 18px; }
.profile-avatar { display: grid; place-items: center; flex: 0 0 44px; height: 44px; border-radius: 15px; background: linear-gradient(135deg, #e1eee5, #f4ebdf); color: #427463; font-size: 15px; font-weight: 700; }
.sidebar-panel h2 { font-size: 16px; font-weight: 650; line-height: 1.5; margin: 14px 0 8px; }
.sidebar-panel .student-name { font-size: 15px; margin: 0; text-transform: capitalize; overflow-wrap: anywhere; }
.coach-name { display: block; font-size: 14px; margin-top: 18px; overflow-wrap: anywhere; }
.phone-link { display: flex; align-items: center; gap: 8px; color: var(--brand-link); font-size: 14px; font-weight: 600; margin-top: 8px; }
.phone-link:hover { text-decoration: underline; }
.support-loading { color: #637480; font-size: 12px; margin-top: 18px; }
.faq-link { display: flex; align-items: center; gap: 12px; min-height: 64px; padding: 16px 18px; border: 1px solid #87cbb4; border-radius: 14px; background: var(--brand-soft); color: var(--brand-link); font-size: 14px; font-weight: 700; box-shadow: 0 4px 12px #00856a12; transition: background-color .2s ease, border-color .2s ease, box-shadow .2s ease; }
.faq-link > .bi:first-child { display: inline-grid; place-items: center; flex: 0 0 36px; width: 36px; height: 36px; border-radius: 10px; background: white; font-size: 20px; }
.faq-link > .bi:last-child { margin-left: auto; }
.faq-link:hover { background: #deeee5; border-color: var(--brand-primary); color: var(--brand-link); box-shadow: 0 6px 16px #00856a24; }
.section-heading { margin-bottom: 16px; }
.section-heading h2 { font-size: 20px; font-weight: 700; margin: 0 0 6px; }
.progress-section :deep(.card) { border: 1px solid #e4ecef !important; border-radius: 16px !important; box-shadow: none; }
.progress-section :deep(.card-body) { padding: 24px; }
.progress-section :deep(.card) { margin-bottom: 0 !important; }
a:focus-visible, button:focus-visible { outline: 3px solid #cf9c30; outline-offset: 4px; }
@media (max-width: 991px) {
  .education-layout { grid-template-columns: minmax(0, 1fr); }
  .education-sidebar { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .faq-link { grid-column: 1 / -1; }
}
@media (max-width: 575px) {
  .education-main { padding: 28px 18px; }
  .page-heading { align-items: flex-start; flex-direction: column; gap: 18px; }
  .lesson-panel { padding: 24px; flex-direction: column-reverse; align-items: stretch; gap: 18px; }
  .lesson-art { flex: none; width: 100%; max-width: 260px; align-self: center; }
  .quick-links, .education-sidebar { grid-template-columns: minmax(0, 1fr); }
  .progress-section :deep(.card-body) { padding: 18px; }
}
</style>
